module.exports = __webpack_public_path__ + "static/media/teeth-open.14ced281.svg";